//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'common/components/core/router';
import { compose } from 'recompose';
import { translate, Trans } from 'react-i18next';
import { getEventNotifications } from 'common/redux/selectors/appPreferences';
import { dismissablePopoverFactory } from 'common/components/core/popover/DismissiblePopover';
import classnames from 'classnames';
import { toggleNotificationInfo } from 'common/redux/actions/eventNotifications';
import InfoPopoverTheme from 'common/components/core/popover/InfoPopover.scss';
import { Portal } from 'react-portal';

const NotificationInfo = props => {
    const { theme } = props;
    return (
        <div className={theme.notificationInfoWrapper}>
            <Trans i18nKey="allowNotifications">
                <div className={theme.row}>
                    <span>Press the</span>
                    <img
                        className={classnames(theme.image, theme.buttonImage)}
                        src={'/img/notification-info-button.png'}
                    />
                    <span>icon on the address bar & Allow</span>
                </div>
                <div className={theme.row}>
                    <img
                        className={classnames(theme.image, theme.barImage)}
                        src={'/img/notification-bar.png'}
                    />
                    to switch <span className={theme.greenText}>ON</span>{' '}
                    notifications
                </div>
            </Trans>
        </div>
    );
};

const InfoPopover = dismissablePopoverFactory({
    InnerComponent: NotificationInfo
});

class EventNotificationHandlerBase extends React.Component {
    handlePopoverClose = flag => {
        const { toggleNotificationInfo } = this.props;
        toggleNotificationInfo(flag);
    };
    render() {
        const { notificationInfoActive } = this.props;
        if (!notificationInfoActive) {
            return null;
        }
        return (
            <Portal>
                <InfoPopover
                    theme={InfoPopoverTheme}
                    active={notificationInfoActive}
                    onPopoverClose={this.handlePopoverClose}
                />
            </Portal>
        );
    }
}
const EventNotificationHandler = compose(
    withRouter,
    translate(),
    connect(
        state => {
            const eventNotificationsPreferences = getEventNotifications(state);

            let notificationInfoActive = false;
            if (
                eventNotificationsPreferences &&
                eventNotificationsPreferences.notificationInfoActive
            ) {
                ({ notificationInfoActive } = eventNotificationsPreferences);
            }
            return { notificationInfoActive };
        },
        {
            toggleNotificationInfo
        }
    )
)(EventNotificationHandlerBase);

export default EventNotificationHandler;
export { EventNotificationHandler };
